var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6964 3.97108C18.4675 3.39277 19.1614 2.6988 19.7012 1.88916C19.0072 2.19759 18.1976 2.42892 17.388 2.50602C18.2361 2.00482 18.853 1.23373 19.1614 0.269879C18.3904 0.73253 17.5036 1.07952 16.6169 1.27229C15.8458 0.462651 14.8048 0 13.6482 0C11.412 0 9.6 1.81205 9.6 4.04819C9.6 4.35663 9.63855 4.66506 9.71566 4.97349C6.36145 4.78072 3.35422 3.16145 1.3494 0.73253C1.00241 1.31084 0.809639 2.00482 0.809639 2.7759C0.809639 4.16386 1.50361 5.39759 2.62169 6.13012C1.96626 6.09157 1.31084 5.93735 0.771084 5.62892V5.66747C0.771084 7.63373 2.15904 9.25301 4.00964 9.63855C3.7012 9.71566 3.31566 9.79277 2.96867 9.79277C2.6988 9.79277 2.46747 9.75422 2.19759 9.71566C2.6988 11.3349 4.20241 12.4916 5.9759 12.5301C4.58795 13.6096 2.85301 14.2651 0.963855 14.2651C0.616867 14.2651 0.308434 14.2265 0 14.188C1.77349 15.3446 3.89398 16 6.20723 16C13.6482 16 17.6964 9.86988 17.6964 4.51084C17.6964 4.31807 17.6964 4.16386 17.6964 3.97108Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4b44f5502d8df8dff8ba4869899331ce.svg";
export { ForwardRef as ReactComponent };